var React = require('react');

function ContactIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.126 21.875a2.75 2.75 0 0 1-2.75 2.75h-16.5l-5.5 5.5v-22a2.75 2.75 0 0 1 2.75-2.75h19.25a2.75 2.75 0 0 1 2.75 2.75z","transform":"translate(-1.72 -1.25)","style":{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2px"},"data-name":"Icon"}));
}

ContactIcon.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33"};

module.exports = ContactIcon;

ContactIcon.default = ContactIcon;
